import React, { Fragment, useState } from "react";
import { makeStyles } from "@mui/styles";
import MenuUsuario from "../MenuUsuario/MenuUsuario";
import MenuApps from "../MenuApps/MenuApps";
import ButtonEjecucionPagina from "../EjecucionPagina/ButtonEjecucionPagina";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuConfiguraciones from "../Configuraciones/MenuConfiguraciones/MenuConfiguraciones";

const useStyles = makeStyles((theme) => ({
  toolbarUsuario: {
    display: 'none',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  mobileToolbarUsuario: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  UsuarioLog: {
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-end",
  },
  MonedaSelector: {
    color: "white",
    marginLeft: "10px",
    marginRight: "10px",
  },  
  menuItem: {
    display: "flex", 
    flexDirection: "row",
    alignItems: "center",
    justifyContent: 'flex-start',
  },
}));

const ToolbarComponents = () => {
  const classes = useStyles(); 

  //#region  Toolbar Usuario
  const toolbarUsuario = () => {
    return (
      <Fragment>
        <ButtonEjecucionPagina />
        <MenuApps iconSize="25px" />
        <div className={classes.UsuarioLog}>
          <MenuUsuario />
        </div>
      </Fragment>
    )
  }

  //#endregion

  //#region Mobile Toolbar Usuario
  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = useState(null);
  const openMore = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const mobileToolbarUsuario = () => {
    return (
      <Fragment>
        <ButtonEjecucionPagina />
        <div className={classes.MenuConfiguraciones} style={{ display: 'flex', alignItems: 'center' }}>
          <MenuConfiguraciones iconSize="25px" />
        </div>
        <MoreVertIcon
          onClick={handleClick}
          style={{ color: 'white', fontSize: '1.8rem', cursor: 'pointer' }}
        />
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={openMore}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              backgroundColor: 'RGB(81,81,81)',
            },
          }}
        >
          <MenuItem className={classes.menuItem}>
            <MenuApps iconSize="25px" />
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }

  //#endregion

  return (
    <Fragment>
      <div className={classes.toolbarUsuario}>
        {toolbarUsuario()}
      </div>
      
      <div className={classes.mobileToolbarUsuario}>
        {mobileToolbarUsuario()}
      </div>
    </Fragment>
  );
};

export default ToolbarComponents;